import React, { memo } from 'react';
import Table from './table';
import { CardList } from './card-list';
import { IDataGridMadel, IDataGridRowProps } from '../model';
import { NativeScrollProps } from 'components/native-scroll';

interface Props {
  /** The card-mode switch (`useDataGridCardMode`): viewport below md AND the config did not opt out. */
  isCardMode: boolean;
  model: IDataGridMadel;
  data: any[];
  sortable: any;
  pagination: any;
  isHideSwap: boolean;
  preview?: boolean;
  rowControls?: any;
  rowProps?: IDataGridRowProps;
  ScrollProps?: Partial<NativeScrollProps>;
}

/**
 * Renders the rows either as the table (at and above md, and below it for a
 * config that opted out) or as the card list (below md). Kept as its own
 * component so the switch is a unit under test without the grid's data layer.
 */
export const DataView = memo<Props>(({ isCardMode, ...props }) => {
  if (isCardMode) {
    return (
      <CardList
        model={props.model}
        data={props.data}
        rowControls={props.rowControls}
        rowProps={props.rowProps}
      />
    );
  }
  return <Table {...props} />;
});
